/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The UserPermission model module.
 * @module model/UserPermission
 * @version 1.0.0
 */
export default class UserPermission {
  /**
   * Constructs a new <code>UserPermission</code>.
   * @alias module:model/UserPermission
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>UserPermission</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserPermission} obj Optional instance to populate.
   * @return {module:model/UserPermission} The populated <code>UserPermission</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserPermission()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('user_id')) {
        obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number')
      }
      if (data.hasOwnProperty('room_id')) {
        obj['room_id'] = ApiClient.convertToType(data['room_id'], 'Number')
      }
      if (data.hasOwnProperty('config_allowed')) {
        obj['config_allowed'] = ApiClient.convertToType(data['config_allowed'], 'Boolean')
      }
      if (data.hasOwnProperty('report_allowed')) {
        obj['report_allowed'] = ApiClient.convertToType(data['report_allowed'], 'Boolean')
      }
      if (data.hasOwnProperty('reception_allowed')) {
        obj['reception_allowed'] = ApiClient.convertToType(data['reception_allowed'], 'Boolean')
      }
      if (data.hasOwnProperty('cleaning_manage_allowed')) {
        obj['cleaning_manage_allowed'] = ApiClient.convertToType(data['cleaning_manage_allowed'], 'Boolean')
      }
      if (data.hasOwnProperty('cleaning_allowed')) {
        obj['cleaning_allowed'] = ApiClient.convertToType(data['cleaning_allowed'], 'Boolean')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} user_id
   */
  user_id = undefined
  /**
   * @member {Number} room_id
   */
  room_id = undefined
  /**
   * @member {Boolean} config_allowed
   */
  config_allowed = undefined
  /**
   * @member {Boolean} report_allowed
   */
  report_allowed = undefined
  /**
   * @member {Boolean} reception_allowed
   */
  reception_allowed = undefined
  /**
   * @member {Boolean} cleaning_manage_allowed
   */
  cleaning_manage_allowed = undefined
  /**
   * @member {Boolean} cleaning_allowed
   */
  cleaning_allowed = undefined
}
